<template>
  <div>
    <b-row class="align-items-start mb-2">
      <b-col>
        <div class="text-md text-thick">
          Audio - {{ name }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <input-field
          name="preset_audio-codec"
          label="Audio Codec"
          label-position="top"
          :info="audioInfo.audioCodec"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ getText(audioDescription.codecTypeOptions,audioDescription.codecType) }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        sm="6"
      >

        <input-field
          name="preset_audio-codec_profile"
          label="Profile"
          label-position="top"
        >
          <div>
            {{ getText(audioDescription.codecProfileOptions,audioDescription.codecProfile) }}
          </div>
        </input-field>

      </b-col>
      <b-col
        cols="12"
        sm="6"
      >

        <input-field
          name="preset_audio-bitrate_control_mode"
          label="Bitrate Control mode"
          label-position="top"
          :info="audioInfo.bitrateControlMode"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ getText(audioDescription.rateControlModeOptions,audioDescription.rateControlMode) }}
          </div>
        </input-field>

      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          name="preset_audio-coding_mode"
          label="Coding mode"
          label-position="top"
          :info="audioInfo.codingMode"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ getText(audioDescription.codingModeOptions,audioDescription.codingMode) }}
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          name="preset_audio-bitrate"
          label="Bitrate (kbit/s)"
          label-position="top"
          :info="audioInfo.bitrate"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ audioDescription.bitrate / 1000 }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <input-field
          name="preset_audio-sample_rate"
          label="Sample rate (kHz)"
          label-position="top"
          :info="audioInfo.sampleRate"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ audioDescription.sampleRate / 1000 }}
          </div>
        </input-field>
      </b-col>
      <b-col />
    </b-row>
    <b-row class="border-default border-t mb-2" />
    <b-row>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          name="preset_audio-raw_format"
          label="Raw Format"
          label-position="top"
          :info="audioInfo.rawFormat"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ getText(audioDescription.rawFormatOptions,audioDescription.rawFormat) }}
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          name="preset_audio-specification"
          label="Specification"
          label-position="top"
          :info="audioInfo.specification"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ getText(audioDescription.specificationOptions,audioDescription.specification) }}
          </div>
        </input-field>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          name="preset_audio-audio_description_broadcaster_mix"
          label="Audio Description Broadcaster Mix"
          label-position="top"
          :info="audioInfo.broadcasterMix"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ getText(audioDescription.audioDescriptionBroadcasterMixOptions,audioDescription.audioDescriptionBroadcasterMix) }}
          </div>
        </input-field>
      </b-col>
      <b-col
        cols="12"
        sm="6"
      >
        <input-field
          name="preset_audio-transcribe"
          label="Transcribe"
          label-position="top"
          :info="audioInfo.transcribe"
          info-position="label"
          @openInfo="openInfo"
        >
          <div>
            {{ audioDescription.transcribe }}
          </div>
        </input-field>
      </b-col>
      <b-col />
    </b-row>
  </div>

</template>

<script>

import helpers from '@/mixins/helpers'

import InputField from '@/components/form/InputField.vue'

import audioInfo from '../settings/audioInfo'

export default {
  name: 'AudioSettings',
  components: {
    InputField,
  },
  mixins: [helpers],
  data() {
    return {
      audioInfo,
      audioDescription: null,
    }
  },
  computed: {
    name() {
      return this.audioDescription.codecTypeOptions.find(cto => cto.id === this.audioDescription.codecType).value
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const emptyModel = { ...this.$store.state.outputPresets.emptyOutputPreset.audioDescription }
      this.audioDescription = { ...(this.$store.state.outputPresets.outputPreset?.audioDescription || emptyModel) }
    },
    getRateOptions(options) {
      return options.map(opt => ({ value: parseFloat(opt) * 1000, text: opt }))
    },
    openInfo(e) {
      this.$emit('openInfo', e)
    },
  },

}
</script>
